import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import HomePage from './pages/homePage';
import ContactPage from './pages/contact';
import Consulting from './pages/consulting';
import AboutPage from './pages/about';
import DataAI from './pages/servicesDataAI';
import Automation from './pages/servicesAutomation';
import Dev from './pages/servicesDev';
import BlogPage from './pages/blog';
import BlogPostPage from './pages/blogPost';
import MentionsLegales from './pages/mentionsLegales';

function Main(){

    return(
        <Routes>
            <Route path='/' element={<HomePage/>}></Route>
            <Route path='/services/data-ai' element={<DataAI/>}></Route>
            <Route path='/services/automation' element={<Automation/>}></Route>
            <Route path='/services/dev' element={<Dev/>}></Route>
            <Route path='/blog' element={<BlogPage/>}></Route>
            <Route path='/blog/:slug' element={<BlogPostPage/>}></Route>
            <Route path='/contact' element={<ContactPage/>}></Route>
            <Route path='/consulting' element={<Consulting/>}></Route>
            <Route path='/about' element={<AboutPage/>}></Route>
            <Route path='/mentions-legales' element={<MentionsLegales/>}></Route>

            {/* Legacy routes consolidated into the pages above: redirect to preserve any existing links/bookmarks and avoid duplicate content */}
            <Route path='/services/task-automation' element={<Navigate to='/services/automation' replace/>}></Route>
            <Route path='/services/data-analytics' element={<Navigate to='/services/data-ai' replace/>}></Route>
            <Route path='/services/data-acquisition' element={<Navigate to='/services/data-ai' replace/>}></Route>
            <Route path='/services/ai-ml' element={<Navigate to='/services/data-ai' replace/>}></Route>
            <Route path='/services/development' element={<Navigate to='/services/dev' replace/>}></Route>
            <Route path='/services/system-architecture' element={<Navigate to='/services/dev' replace/>}></Route>
            <Route path='/services/website-creation' element={<Navigate to='/services/dev' replace/>}></Route>
            <Route path='*' element={<Navigate to='/' replace/>}></Route>
        </Routes>
    );
}

export default Main;
